// extracted by mini-css-extract-plugin
export default {"dempyou":"a4-render_dempyou__qY94l"};